<template>
    <v-app class="news-page news-article-page">
        <v-flex v-if="article">
            <v-container class="news-page__container news-article-page__container">
                <v-layout wrap>
                    <v-flex xs12 sm12 md10 lg8 class="offset-md-1 offset-lg-2">
                        <a href="/news">Все новости</a>
                        <h2 v-html="article.title"></h2>
                        <v-flex v-html="article.text"></v-flex>
                    </v-flex>
                </v-layout>
            </v-container>
            <div class="news-page__container image-full" v-if="article.additional_img">
                <img :src="article.additional_img_path"/>
            </div>
            <v-container class="news-page__container additional-info" v-if="article.additional_info">
                <v-layout wrap row>
                    <v-flex xs12 sm12 md10 lg8 class="offset-md-1 offset-lg-2">
                        <v-layout wrap row>
                            <v-layout wrap row>
                                <v-flex xs12 class="grey-block">
                                    <h3>Справка</h3>
                                    <p v-html="article.additional_info"></p>
                                </v-flex>
                            </v-layout>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-container class="news-page__container bottom-link">
                <v-layout wrap>
                    <v-flex xs12 sm12 md10 lg8 class="offset-md-1 offset-lg-2">
                        <a href="/news">Все новости</a>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-flex>
<!--        <v-flex v-else>-->
<!--            <v-container class="news-page__container" v-else>-->
<!--                <a href="/news">Все новости</a>-->
<!--                <h2>Новость не существует</h2>-->
<!--            </v-container>-->
<!--        </v-flex>-->
    </v-app>
</template>
<script>
    export default {
        props: ['category', 'article'],
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/NewsArticlePage.vue